<template>
  <div class="home"
       :style="'background-color:'+bgColor">
    <swiper :options="swiperOption">
      <swiper-slide v-for="item in bannerData"
                    :key="item.color">
        <div class="swiperText">
          <div class="itemTitle">{{item.title}}</div>
          <div class="itemTime">{{item.time}}</div>
          <div class="itemContent">{{item.content}}</div>
          <div class="contentBig">{{item.contentBig}}</div>
          <div class="contImg"
               v-if="item.contImg"><img :src="item.contImg"
                 width="267px"></div>
          <div v-if="item.contentSmall"
               class="contentSmall"><span v-for="item1 in item.contentSmall"
                  :key="item1">{{item1}}</span></div>
          <div class="itemBtn"
               @click="jump(item)">
            <span>了解更多</span>
            <img src="@/assets/home/swiperItemBtn.png"
                 alt="">
          </div>
        </div>
        <div class="swiperImg">
          <img :src="item.imgUrl"
               alt="">
        </div>
      </swiper-slide>
      <!-- <div class="swiper-pagination"
           slot="pagination"></div>
      <div class="swiper-button-prev"
           slot="button-prev">
        <span><img src="@/assets/home/left.png"
               width="20px"></span>
      </div>
      <div class="swiper-button-next"
           slot="button-next">
        <img src="@/assets/home/right.png"
             width="20px">
      </div> -->
    </swiper>
  </div>
</template>

<script>
import banner0 from "@/assets/home/banner0.png";
import banner1 from "@/assets/home/banner1.png";
import banner2 from "@/assets/home/banner2.png";
import banner3 from "@/assets/home/banner3.png";
import contImg from "@/assets/home/contImg1.png";
export default {
  name: 'home',
  data () {
    const self = this
    return {
      bgColor: '#0057C9',
      isOne: true,
      bannerData: Object.freeze([
        {
          type: '3',
          color: '#507ECA',
          title: '珠海一号03组卫星',
          contentBig: '发射成功',
          contentSmall: ['五星再征航天路', '大漠腾空问苍穹'],
          time: '2019年9月19日 14:42',
          imgUrl: banner0,
          routerName: 'zhuHai01',
          parameter: '2'
        },
        {
          type: '1',
          color: '#0057C9',
          title: '珠海一号卫星星座',
          imgUrl: banner1,
          content: '“珠海一号”卫星星座，是我国首个由民营上市企业发射并运营的商业遥感微纳卫星星座。整个星座由分布在不同轨道的34颗卫星组成，包括视频卫星、高光谱卫星、雷达卫星、高分光学卫星和红外卫星。卫星星座组网后，对特定地区将实现每天不低于8次重访。',
          routerName: 'zhuHai01'
        },
        {
          type: '1',
          color: '#0092B3',
          title: '数据快递',
          imgUrl: banner2,
          content: '数据快递是通过在线的形式提供在线卫星影像交易及卫星数据定制服务。在线服务提供多时相数据查询、卫星轨道预测、卫星编程摄影、数据定制等标准影像数据服务。同时提供区域镶嵌影像、正射影像服务。平台主要提供的产品有OVS-1A/1B和高光谱卫星数据，后续会陆续推出更多第三方平台的卫星数据及数据服务。',
          routerName: 'dataExpress'
        },
        {
          type: '2',
          color: '#081A29',
          contImg: contImg,
          url: 'https://ohs.obtdata.com/#/',
          imgUrl: banner3
        }
      ]),
      swiperOption: {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        speed: 1000,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        // autoplay: {
        //   delay: 5000,
        //   disableOnInteraction: false
        // },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        on: {
          slideChangeTransitionStart: function () {
            if (!self.isOne) {
              let _index = this.activeIndex;
              if (_index > self.bannerData.length) {
                _index = 1;
              } else if (_index == 0) {
                _index = self.bannerData.length;
              }
              self.bgColor = self.bannerData[_index - 1].color;
            }
            self.isOne = false;
          },
        }
      }
    }
  },
  created () {
    this.bgColor = this.bannerData[0].color;
  },
  methods: {
    jump (data) {
      if (data.routerName) {
        this.$router.push({
          name: data.routerName, params: {
            index: data.parameter
          }
        });
      } else if (data.url) {
        // window.open(data.url,'_blank');
        window.location.href = data.url;
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
.home
  height 100%
  transition background 0.5s

  .swiper-container
    height 100%

  .swiper-slide
    padding-top 60px
    box-sizing border-box
    position relative

  .itemContent
    width 80%
    margin 0 auto
    font-size 12px
    line-height 24px

  .swiper-pagination-bullet
    width 50px
    height 4px
    background rgb(0, 0, 0)
    border-radius 1px
    opacity 0.3

  .swiper-pagination-bullet-active
    opacity 1
    background #fff

  .swiper-button-prev
    left 0

  .swiper-button-next
    right 0

.swiperImg
  width 100%
  position absolute
  bottom 0
  font-size 0
  max-height 60%
  img
    width 100%

.swiperText
  text-align center
  color #fff

.itemTitle
  font-size 30px
  font-weight bold
  line-height 80px

.itemTime
  font-size 19px

.contentBig
  font-size 30px
  font-weight bold
  line-height 76px

.contentSmall
  font-size 16px
  display flex
  justify-content center

  span
    &:first-child
      margin-right 20px

.itemBtn
  display flex
  align-items center
  justify-content center
  width 80%
  margin 20px auto
  font-size 14px
  color #3de4ce
  z-index 99
  img
    width 16px
    margin-left 5px

.contImg
  margin-top 50px
  z-index 99
.swiper-button-prev, .swiper-button-next
  font-size 0
  width auto
  height auto
  background rgba(0, 0, 0, 0)
  display flex
  justify-content center
  font-weight bold
  align-items center
  box-sizing border-box
  border-right none
  margin-top -30px
  border none

.swiper-button-next:after, .swiper-container-rtl .swiper-button-prev:after, .swiper-button-prev:after, .swiper-container-rtl .swiper-button-next:after
  display none

/*
.home{
  height: 100%;
  transition: background 0.5s;
}
.home .swiper-container{
  height: 100%;
}
.home .swiper-slide{
  padding-top: 60px;
  box-sizing: border-box;
  position: relative;
}
.swiperImg{
  width: 100%;
  position: absolute;
  bottom: 0;
  font-size: 0;
}
.swiperImg img{
  width: 100%;
}
.swiperText{
  text-align: center;
  color: #fff;
}
.itemTitle{
  font-size: 30px;
  font-weight: bold;
  line-height: 80px;
}
.itemTime{
  font-size: 19px;
}
.contentBig{
  font-size: 30px;
  font-weight: bold;
  line-height: 76px;
}
.contentSmall{
  font-size: 16px;
  display: flex;
  justify-content: center;
}
.contentSmall span:first-child{
  margin-right: 20px;
}
.itemBtn{
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: #3DE4CE;
}
.itemBtn img{
  width: 16px;
  margin-left: 5px;
}
.home .itemContent{
  width: 80%;
  margin: 0 auto;
  font-size: 12px;
  line-height: 24px;
}
.contImg{
  margin-top: 50px;
}
.home .swiper-pagination-bullet{
  width:50px;
  height:4px;
  background:rgb(0,0,0);
  border-radius: 1px;
  opacity: 0.3;
}
.home .swiper-pagination-bullet-active{
  opacity: 1;
  background: #fff;
}
.swiper-button-prev,.swiper-button-next{
  font-size: 0;
  width: auto;
  height: auto;
  background:rgba(0,0,0,0);
  display: flex;
  justify-content: center;
  font-weight: bold;
  align-items: center;
  box-sizing: border-box;
  border-right: none;
  margin-top:-30px;
  border: none;
}
.home .swiper-button-prev{
  left: 0;
}
.home .swiper-button-next{
  right: 0;
}
*/
</style>
